import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { UserService } from '@cutting/main/shared/services/user.service';
import { MyValidator } from 'cloud-shared-lib';
import { Subject, of } from 'rxjs';
import { catchError, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'cutting-change-email',
  templateUrl: './change-email.component.html',
  styleUrls: ['./change-email.component.scss'],
})
export class ChangeEmailComponent implements OnInit, OnDestroy {
  changeEmailForm: UntypedFormGroup;
  changeEmailFormErrors: any;
  submitting = false;

  unsubscribe$: Subject<void> = new Subject();

  constructor(
    private formBuilder: UntypedFormBuilder,
    private userService: UserService,
    private snackBar: MatSnackBar
  ) {
    this.changeEmailFormErrors = {
      oldPassword: {},
      newPassword: {},
    };
  }

  ngOnInit(): void {
    this.changeEmailForm = this.formBuilder.group({
      newEmail: ['', [Validators.required, MyValidator.email]],
    });

    this.changeEmailForm.valueChanges.pipe(takeUntil(this.unsubscribe$)).subscribe(() => {
      this.onChangeEmailFormValuesChanged();
    });
  }

  onChangeEmailFormValuesChanged(): void {
    for (const field in this.changeEmailFormErrors) {
      // Clear previous errors
      this.changeEmailFormErrors[field] = {};

      // Get the control
      const control = this.changeEmailForm.get(field);

      if (control && control.dirty && !control.valid) {
        this.changeEmailFormErrors[field] = control.errors;
      }
    }
  }

  onSubmitChangeEmailForm(): void {
    this.submitting = true;

    if (this.changeEmailForm.valid) {
      this.userService
        .sendChangeEmailMess(this.changeEmailForm.controls.newEmail.value)
        .pipe(
          takeUntil(this.unsubscribe$),
          catchError(() => {
            this.snackBar.open($localize`Не удалось применить изменения`);
            this.submitting = false;

            return of(false);
          })
        )
        .subscribe(() => {
          this.snackBar.open($localize`Письмо для подтверждения Email отправлено`);
          this.submitting = false;
        });
    }
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
  }
}
